<ng-container *transloco="let t">
  <pxw-modal-dialog
    #stockErrorsDialog
    [title]="t('stockErrorsDialog.title')"
    [acceptText]="t('stockErrorsDialog.acceptText')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('stockErrorsDialog.description') }}</p>
      <table class="stock-errors">
        <thead>
          <tr>
            <th class="product">{{ t('stockErrorsDialog.product') }}</th>
            <th class="stock">{{ t('stockErrorsDialog.before') }}</th>
            <th class="stock">{{ t('stockErrorsDialog.after') }}</th>
          </tr>
        </thead>
        <tbody>
          @for (stockError of stockErrors(); track $index) {
            <tr>
              <td class="product">
                @if (stockError.parentName) {
                  <span>{{ stockError.parentName }} - </span>
                }
                <span>{{ stockError.name }}</span>
              </td>
              <td class="stock">
                {{ stockError.requested }}
              </td>
              <td class="stock">
                {{ stockError.available }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
